import Config from '../config';
import { AxiosInstance } from '../helpers/AxiosInstance';


const getAllFeature = () => {
    return AxiosInstance.get(`${Config.API_URL}/api/Features`);
};

const updateFeature = (data: any) => {
    return AxiosInstance.put(`${Config.API_URL}/api/Features`, data);
};

const DisableFeature = (id: any) => {
    return AxiosInstance.patch(`${Config.API_URL}/api/Features/id?id=${id}`);
};

// ---------------------------------------------New SubScription flow ---------------------------------------------
const GetAllNewFeatures = () => {
    return AxiosInstance.get(`${Config.API_URL}/api/SubscriptionFeature`);
}

const CreateNewFeature = (data: any) => {
    return AxiosInstance.post(`${Config.API_URL}/api/SubscriptionFeaturen`, data);
}

const UpdateNewFeature = (data: any) => {
    return AxiosInstance.put(`${Config.API_URL}/api/SubscriptionFeaturen`, data);
}

//need to check with BE
const EnableOrDisableNewFeature = (id: any, isEnabled: boolean) => {
    return AxiosInstance.patch(`${Config.API_URL}/api/SubscriptionFeature/${id}?isEnabled=${isEnabled}`);
}

export const FeatureService = {
    getAllFeature,
    updateFeature,
    DisableFeature,
    GetAllNewFeatures,
    CreateNewFeature,
    UpdateNewFeature,
    EnableOrDisableNewFeature
};